export default new class CartChange {
  constructor() {
    this.changeBtnClass = 'cart__btn_change';
    this.handler();
  }

  handler() {
    const changeBtns = document.querySelectorAll(`.${this.changeBtnClass}`);
    this.changeValues(changeBtns);
  }

  changeValues(changeBtns) {
    changeBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        if (e.target.value == 1) {
          this.hideAddresses();
        } else {
          this.showAddresses();
        }
      });
    });
  }

  showAddresses() {
    const cartAddress = document.querySelector('.cart__address');
    if (!cartAddress) {
      return;
    }

    cartAddress.classList.add('cart__address--visible');

    cartAddress.querySelector('[type="radio"]').setAttribute('checked', 'checked');

    this.initAddresses()
  }

  hideAddresses() {
    const cartAddress = document.querySelector('.cart__address');
    if (!cartAddress) {
      return;
    }

    cartAddress.classList.remove('cart__address--visible');
  }

  initAddresses() {
    const newAddress = document.querySelector('#address-new');

    if (!newAddress) {
      return;
    }

    if (newAddress.checked) {
      this.showAddressForm();
      return;
    }

    newAddress.addEventListener('change', (e) => {
      if (e.target.checked) {
        this.showAddressForm();
      }
    });

    const addresses = document.querySelectorAll('.cart__list-item_address');
    addresses.forEach(address => {
      address.addEventListener('change', (e) => {
        if (e.target.checked) {
          this.hideAddressForm();
        }
      })
    })
  }

  showAddressForm() {
    const addressForm = document.querySelector('.cart__address_form');

    if (!addressForm) {
      return;
    }

    addressForm.classList.add('cart__address_form--visible');

    const address = addressForm.querySelector('#person-address');
    const city = addressForm.querySelector('#person-city');

    address.setAttribute('required', 'required');
    city.setAttribute('required', 'required');

  }

  hideAddressForm() {
    const addressForm = document.querySelector('.cart__address_form');

    if (!addressForm) {
      return;
    }

    const address = addressForm.querySelector('#person-address');
    const city = addressForm.querySelector('#person-city');

    address.removeAttribute('required');
    city.removeAttribute('required');

    addressForm.classList.remove('cart__address_form--visible');
  }
}();
